import { useEffect, useState } from 'react';

import { profileApi } from '@pukka/api';
import { routes } from '@pukka/common/utils';

interface ProtectedProps {
  readonly children: JSX.Element;
}

function Protected({ children }: ProtectedProps) {
  const { data: profile, isFetched } = profileApi.useProfile();

  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    if (isFetched) {
      const isDestinationPermitted = routes.isDestinationPermitted(
        profile?.business?.is_mokapos_user ?? false,
        profile?.permissions,
        window.location.pathname,
      );

      if (!isDestinationPermitted) {
        window.location.replace('/');
      }

      setIsAllowed(isDestinationPermitted);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched, profile?.permissions, window.location.pathname]);

  return isAllowed ? children : null;
}

export { Protected as ProtectedNavigation };
